import { render, staticRenderFns } from "./ContactRequest.vue?vue&type=template&id=23ca7196&"
import script from "./ContactRequest.vue?vue&type=script&lang=js&"
export * from "./ContactRequest.vue?vue&type=script&lang=js&"
import style0 from "./ContactRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports